module.exports = __webpack_public_path__ + "img/done.49e2c9e6.png";